import { render, staticRenderFns } from "./Ecommerce.vue?vue&type=template&id=553df2bf&"
import script from "./Ecommerce.vue?vue&type=script&lang=ts&"
export * from "./Ecommerce.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports